/* New Theory Waitlist — Shopify theme asset (Resend via Apps Script) */
(function () {
  "use strict";

  var CONFIG = {
    assets: {
      logo: "https://cdn.shopify.com/s/files/1/0622/9059/1984/files/logo.jpg?v=1779627707",
      video1:"https://cdn.shopify.com/videos/c/o/v/b5c7b78801874f948a90c3f8780f205e.mp4",
      video2:"https://cdn.shopify.com/videos/c/o/v/6e10449c50c44790a89858215831dcd6.mp4",
      video3:"https://cdn.shopify.com/videos/c/o/v/f8c0275d5c414b71ac7213c6b22ce71a.mp4",
      videoThumb1:"https://cdn.shopify.com/s/files/1/0622/9059/1984/files/Screenshot_2026-06-08_at_11.19.02_AM.png?v=1780897870",
      videoThumb2:"https://cdn.shopify.com/s/files/1/0622/9059/1984/files/Screenshot_2026-06-08_at_11.20.01_AM.png?v=1780897871",
      videoThumb3:"https://cdn.shopify.com/s/files/1/0622/9059/1984/files/Screenshot_2026-06-08_at_11.19.28_AM.png?v=1780897870",
      product1:"https://cdn.shopify.com/s/files/1/0622/9059/1984/files/843A4143_1.jpg?v=1780819284",
      product2:"https://cdn.shopify.com/s/files/1/0622/9059/1984/files/843A3041_1.jpg?v=1780819284",
      product3:"https://cdn.shopify.com/s/files/1/0622/9059/1984/files/843A3548_1.jpg?v=1780819284",
      product4:"https://cdn.shopify.com/s/files/1/0622/9059/1984/files/843A2151_1_1.jpg?v=1780819284",
    },
    sheets_webhook_url:
      "https://script.google.com/macros/s/AKfycbycK151xJl3mYDDU8LMnFQqG6HXNZy0kS8btjM_QLd8RbY-DjKUgkmFKzltUYoePbXyPw/exec",
    brand_name: "New Theory",
  };

  var _emailVerified = false;
  var _timerInterval = null;
  var _formOnly = false;

  function $(id) {
    return document.getElementById(id);
  }

  function normalizeEmail(email) {
    return String(email || "")
      .trim()
      .toLowerCase();
  }

  function showScreen(name) {
    var landing = $("screen-landing");
    var waitlist = $("screen-waitlist");
    var success = $("screen-success");
    if (landing) landing.classList.add("hidden");
    if (waitlist) waitlist.classList.add("hidden");
    if (success) success.classList.add("hidden");
    var target = $("screen-" + name);
    if (target) target.classList.remove("hidden");
    window.scrollTo(0, 0);
    if (name === "landing") {
      document
        .querySelectorAll(
          "#screen-landing .s1-video-main, #screen-landing .s1-video-secondary, #screen-landing .s1-video-third"
        )
        .forEach(function (slot, index) {
          setTimeout(function () {
            var video = slot.querySelector("video");
            var placeholder = slot.querySelector(".s1-video-placeholder");
            startVideoPlayback(video, slot, placeholder);
          }, index * 300);
        });
    }
  }

  function clearMsg() {
    var area = $("msg-area");
    if (area) area.innerHTML = "";
  }

  function showMsg(type, text) {
    var area = $("msg-area");
    if (area) area.innerHTML = '<div class="msg-' + type + '">' + text + "</div>";
  }

  function updateSubmitBtn() {
    var btn = $("btn-submit");
    if (btn) btn.disabled = !_emailVerified;
  }

  function getDialCode() {
    var val = $("inp-country").value;
    var match = val.match(/^\+\d+/);
    return match ? match[0] : "";
  }

  function getWhatsAppFull() {
    var raw = $("inp-phone").value.trim();
    if (!raw) return "";
    var dial = getDialCode();
    var local = raw.replace(/\D/g, "").replace(/^0+/, "");
    if (!local) return "";
    return dial + local;
  }

  function formatTimestamp12hr() {
    return new Date().toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  function getOtpValue() {
    var out = "";
    for (var i = 0; i < 6; i++) out += $("otp-" + i).value;
    return out;
  }

  function sheetsUrlValid() {
    return (
      CONFIG.sheets_webhook_url &&
      CONFIG.sheets_webhook_url.indexOf("YOUR_APPS_SCRIPT") === -1 &&
      CONFIG.sheets_webhook_url.indexOf("docs.google.com/spreadsheets") === -1
    );
  }

  function apiUrl(params) {
    var qs = Object.keys(params)
      .map(function (k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
      })
      .join("&");
    return CONFIG.sheets_webhook_url + "?" + qs;
  }

  function postApi(params) {
    return fetch(CONFIG.sheets_webhook_url, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(params).toString(),
    });
  }

  async function checkEmailExists(email) {
    if (!sheetsUrlValid()) return false;
    var res = await fetch(apiUrl({ action: "checkEmail", email: normalizeEmail(email) }));
    var data = await res.json();
    return data.exists === true;
  }

  function markEmailVerified() {
    _emailVerified = true;
    clearMsg();
    $("email-verified-badge").style.display = "inline-flex";
    $("btn-send-otp").style.display = "none";
    for (var i = 0; i < 6; i++) $("otp-" + i).disabled = true;
    clearInterval(_timerInterval);
    $("otp-timer-wrap").textContent = "";
    updateSubmitBtn();
  }

  async function verifyOtp(entered) {
    clearMsg();
    var email = normalizeEmail($("inp-email").value);

    try {
      var res = await fetch(
        apiUrl({ action: "verifyOtp", email: email, otp: entered })
      );
      var data = await res.json();

      if (data.status === "ok" && data.verified) {
        markEmailVerified();
        return;
      }

      _emailVerified = false;
      updateSubmitBtn();
      showMsg("error", data.message || "Incorrect code. Please try again.");
    } catch (err) {
      console.error("Verify OTP error:", err);
      _emailVerified = false;
      updateSubmitBtn();
      showMsg("error", "Verification failed. Please try again.");
    }
  }

  function setOtpBox(idx, digit) {
    var el = $("otp-" + idx);
    if (!el) return;
    el.value = digit;
    el.classList.toggle("filled", !!digit);
  }

  function fillOtpFromString(str, startIdx) {
    startIdx = startIdx || 0;
    var digits = str.replace(/\D/g, "");
    if (!digits) return;

    for (var i = startIdx; i < 6; i++) setOtpBox(i, "");

    for (var j = 0; j < digits.length && startIdx + j < 6; j++) {
      setOtpBox(startIdx + j, digits[j]);
    }

    var filled = Math.min(startIdx + digits.length, 6);
    var focusIdx = filled >= 6 ? 5 : filled;
    $("otp-" + focusIdx).focus();

    if (getOtpValue().length === 6) verifyOtp(getOtpValue());
  }

  function otpInput(idx) {
    var el = $("otp-" + idx);
    var val = el.value.replace(/\D/g, "");
    if (val.length > 1) {
      fillOtpFromString(val, idx);
      return;
    }
    el.value = val.slice(0, 1);
    el.classList.toggle("filled", !!el.value);
    if (el.value && idx < 5) $("otp-" + (idx + 1)).focus();
    if (getOtpValue().length === 6) verifyOtp(getOtpValue());
  }

  function otpPaste(e, idx) {
    var pasted = (e.clipboardData || window.clipboardData).getData("text");
    if (!pasted || pasted.replace(/\D/g, "").length <= 1) return;
    e.preventDefault();
    fillOtpFromString(pasted, idx);
  }

  function otpKeydown(e, idx) {
    if (e.key === "Backspace") {
      var el = $("otp-" + idx);
      if (!el.value && idx > 0) $("otp-" + (idx - 1)).focus();
    }
  }

  function startOtpTimer(seconds) {
    clearInterval(_timerInterval);
    var remaining = seconds;
    var wrap = $("otp-timer-wrap");

    function tick() {
      if (remaining <= 0) {
        clearInterval(_timerInterval);
        wrap.innerHTML =
          'Didn\'t get it? <button type="button" class="otp-resend" id="btn-otp-resend">Resend</button>';
        var resend = $("btn-otp-resend");
        if (resend) resend.addEventListener("click", sendOtp);
        return;
      }
      wrap.innerHTML =
        'Resend in <span class="highlight">' + remaining + "s</span>";
      remaining--;
    }
    tick();
    _timerInterval = setInterval(tick, 1000);
  }

  async function sendOtp() {
    clearMsg();
    var email = normalizeEmail($("inp-email").value);
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      showMsg("error", "Please enter a valid email address first.");
      return;
    }

    var btn = $("btn-send-otp");
    if (!btn) return;

    if (!sheetsUrlValid()) {
      showMsg("error", "Server not configured. Please contact support.");
      return;
    }

    btn.disabled = true;
    btn.textContent = "Sending…";

    try {
      var res = await fetch(apiUrl({ action: "sendOtp", email: email }));
      var data = await res.json();
      console.log("sendOtp response:", data);

      if (data.status === "duplicate") {
        showMsg("error", data.message);
        btn.disabled = false;
        btn.textContent = "Send Code";
        return;
      }

      if (data.status !== "ok" || !data.sent) {
        if (data.detail) console.error("Resend error detail:", data.detail);
        if (!data.apiVersion) {
          console.warn("Old Apps Script deployed — redeploy google-apps-script.gs (New version).");
        }
        showMsg(
          "error",
          data.message ||
            "OTP service not deployed. Paste latest google-apps-script.gs in Apps Script, then Deploy → New version."
        );
        btn.disabled = false;
        btn.textContent = "Send Code";
        return;
      }

      _emailVerified = false;
      updateSubmitBtn();
      $("email-verified-badge").style.display = "none";
      for (var i = 0; i < 6; i++) {
        $("otp-" + i).value = "";
        $("otp-" + i).disabled = false;
        $("otp-" + i).classList.remove("filled");
      }

      $("otp-section").style.display = "block";
      $("otp-0").focus();
      btn.textContent = "Resend";
      btn.classList.add("sent");
      btn.disabled = false;
      btn.style.display = "";
      startOtpTimer(60);
      showMsg("info", "Code sent! Check your inbox (and spam folder).");
    } catch (err) {
      console.error("Send OTP error:", err);
      showMsg("error", "Failed to send code. Please try again.");
      btn.disabled = false;
      btn.textContent = "Send Code";
    }
  }

  async function submitForm() {
    if (!_emailVerified) return;

    var email = normalizeEmail($("inp-email").value);
    var name = $("inp-name").value.trim();
    var whatsapp = getWhatsAppFull();

    if (!name) {
      showMsg("error", "Please enter your name.");
      return;
    }

    if (!sheetsUrlValid()) {
      showMsg("error", "Google Sheets webhook not configured.");
      return;
    }

    var btn = $("btn-submit");
    btn.disabled = true;
    btn.innerHTML = '<div class="spinner"></div> Submitting…';

    try {
      if (await checkEmailExists(email)) {
        showMsg(
          "error",
          "This email is already registered on our waitlist. Please use a different email address."
        );
        btn.disabled = false;
        btn.innerHTML = "Join Waitlist";
        return;
      }

      var body = new URLSearchParams({
        timestamp: formatTimestamp12hr(),
        name: name,
        whatsapp: whatsapp,
        email: email,
      });

      var res = await fetch(CONFIG.sheets_webhook_url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });

      var data = await res.json();

      if (data.status === "duplicate") {
        showMsg("error", data.message || "This email is already registered.");
        btn.disabled = false;
        btn.innerHTML = "Join Waitlist";
        return;
      }

      if (data.status === "error") {
        showMsg("error", data.message || "Submission failed.");
        btn.disabled = false;
        btn.innerHTML = "Join Waitlist";
        return;
      }

      if (data.status !== "ok") {
        throw new Error(data.message || "Submission failed.");
      }

      if (data.welcomeSent === false) {
        console.warn("Welcome email failed:", data.welcomeError || "unknown");
      }

      $("confirmed-email").textContent = email;
      initProductGallery();
      showScreen("success");
    } catch (err) {
      console.error("Submit error:", err);
      showMsg("error", "Submission failed. Please try again.");
      btn.disabled = false;
      btn.innerHTML = "Join Waitlist";
    }
  }

  function initProductGallery() {
    document.querySelectorAll(".success-product-img[data-asset]").forEach(function (img) {
      var key = img.getAttribute("data-asset");
      var src = CONFIG.assets[key];
      var slot = img.closest(".success-product-slot");
      var placeholder = slot ? slot.querySelector(".success-product-placeholder") : null;

      if (!src || src.indexOf("http") !== 0) {
        img.style.display = "none";
        if (placeholder) placeholder.style.display = "flex";
        return;
      }

      img.onload = function () {
        img.style.display = "block";
        if (placeholder) placeholder.style.display = "none";
      };
      img.onerror = function () {
        img.style.display = "none";
        if (placeholder) placeholder.style.display = "flex";
      };
      img.src = src;
    });
  }

  function revealVideo(slot, placeholder) {
    if (!slot) return;
    slot.classList.add("is-playing");
    if (placeholder) placeholder.classList.add("is-hidden");
  }

  function startVideoPlayback(video, slot, placeholder) {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute("muted", "");
    video.playsInline = true;
    video.setAttribute("playsinline", "");

    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === "function") {
      playPromise
        .then(function () {
          revealVideo(slot, placeholder);
        })
        .catch(function () {
          /* Autoplay blocked — keep thumbnail; tap slot to play */
        });
    }
  }

  function applyVideoSources(slot, video, thumbImg, videoKey, thumbKey) {
    var videoSrc = CONFIG.assets[videoKey];
    var thumbSrc = CONFIG.assets[thumbKey];
    var placeholder = slot.querySelector(".s1-video-placeholder");

    if (thumbSrc) {
      if (thumbImg && !thumbImg.getAttribute("src")) {
        thumbImg.src = thumbSrc;
      }
      if (video && !video.getAttribute("poster")) {
        video.poster = thumbSrc;
      }
      if (placeholder) placeholder.classList.add("has-thumb");
    }

    if (videoSrc && video && !video.getAttribute("src")) {
      video.src = videoSrc;
    }
  }

  function setupVideoSlot(slot, playDelayMs) {
    var video = slot.querySelector("video");
    var placeholder = slot.querySelector(".s1-video-placeholder");
    var thumbImg = slot.querySelector(".s1-video-thumb");
    if (!video) return;

    var videoKey = slot.getAttribute("data-video-key") || "";
    var thumbKey = slot.getAttribute("data-thumb-key") || "";
    applyVideoSources(slot, video, thumbImg, videoKey, thumbKey);

    video.loop = true;
    video.preload = "auto";
    video.autoplay = true;

    var tryPlay = function () {
      startVideoPlayback(video, slot, placeholder);
    };

    var onReady = function () {
      tryPlay();
    };

    video.addEventListener("playing", function () {
      revealVideo(slot, placeholder);
    });

    video.addEventListener(
      "timeupdate",
      function onTime() {
        if (video.currentTime > 0 && !video.paused) {
          revealVideo(slot, placeholder);
          video.removeEventListener("timeupdate", onTime);
        }
      }
    );

    video.addEventListener("canplay", onReady);
    video.addEventListener("loadeddata", onReady);

    video.addEventListener("error", function () {
      console.warn("Video failed to load:", video.currentSrc || video.src);
    });

    slot.addEventListener("click", function () {
      revealVideo(slot, placeholder);
      tryPlay();
    });

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) tryPlay();
          });
        },
        { threshold: 0.05 }
      );
      observer.observe(slot);
    }

    setTimeout(function () {
      if (video.readyState >= 2) {
        tryPlay();
      }
    }, playDelayMs || 0);

    if (video.readyState >= 2) {
      tryPlay();
    }
  }

  function initLandingVideos() {
    var slots = document.querySelectorAll(
      "#screen-landing .s1-video-main, #screen-landing .s1-video-secondary, #screen-landing .s1-video-third"
    );
    slots.forEach(function (slot, index) {
      setupVideoSlot(slot, index * 400);
    });
  }

  function initAssets() {
    document.querySelectorAll("[data-asset]").forEach(function (el) {
      var key = el.getAttribute("data-asset");
      if (!key || key.indexOf("product") === 0 || key.indexOf("video") === 0) return;
      if (CONFIG.assets && CONFIG.assets[key]) {
        var src = CONFIG.assets[key];
        if (src.indexOf("http") === 0) {
          el.src = src;
        }
      }
    });

    initLandingVideos();
  }

  function bindEvents() {
    var landingCta = $("btn-landing-cta");
    var backBtn = $("btn-back");
    if (landingCta)
      landingCta.addEventListener("click", function () {
        showScreen("waitlist");
      });
    if (backBtn)
      backBtn.addEventListener("click", function () {
        showScreen("landing");
      });

    var sendBtn = $("btn-send-otp");
    if (sendBtn) sendBtn.addEventListener("click", sendOtp);

    var submitBtn = $("btn-submit");
    if (submitBtn) submitBtn.addEventListener("click", submitForm);

    var phone = $("inp-phone");
    if (phone) {
      phone.addEventListener("input", function () {
        this.value = this.value.replace(/\D/g, "");
      });
    }

    for (var i = 0; i < 6; i++) {
      (function (idx) {
        var box = $("otp-" + idx);
        if (!box) return;
        box.addEventListener("input", function () {
          otpInput(idx);
        });
        box.addEventListener("keydown", function (e) {
          otpKeydown(e, idx);
        });
        box.addEventListener("paste", function (e) {
          otpPaste(e, idx);
        });
      })(i);
    }
  }

  function readConfigFromDom() {
    var el = document.getElementById("ntc-config");
    if (!el) return;
    _formOnly = el.getAttribute("data-form-only") === "true";
    if (el.getAttribute("data-logo")) CONFIG.assets.logo = el.getAttribute("data-logo");
    if (el.getAttribute("data-video1")) CONFIG.assets.video1 = el.getAttribute("data-video1");
    if (el.getAttribute("data-video2")) CONFIG.assets.video2 = el.getAttribute("data-video2");
    if (el.getAttribute("data-video3")) CONFIG.assets.video3 = el.getAttribute("data-video3");
    if (el.getAttribute("data-video-thumb1"))
      CONFIG.assets.videoThumb1 = el.getAttribute("data-video-thumb1");
    if (el.getAttribute("data-video-thumb2"))
      CONFIG.assets.videoThumb2 = el.getAttribute("data-video-thumb2");
    if (el.getAttribute("data-video-thumb3"))
      CONFIG.assets.videoThumb3 = el.getAttribute("data-video-thumb3");
    if (el.getAttribute("data-product-img-1"))
      CONFIG.assets.product1 = el.getAttribute("data-product-img-1");
    if (el.getAttribute("data-product-img-2"))
      CONFIG.assets.product2 = el.getAttribute("data-product-img-2");
    if (el.getAttribute("data-product-img-3"))
      CONFIG.assets.product3 = el.getAttribute("data-product-img-3");
    if (el.getAttribute("data-product-img-4"))
      CONFIG.assets.product4 = el.getAttribute("data-product-img-4");
    if (el.getAttribute("data-sheets-url"))
      CONFIG.sheets_webhook_url = el.getAttribute("data-sheets-url");
    if (el.getAttribute("data-brand")) CONFIG.brand_name = el.getAttribute("data-brand");
  }

  function init() {
    readConfigFromDom();
    initAssets();
    bindEvents();
    if (_formOnly) showScreen("waitlist");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.NTC_CONFIG = CONFIG;
})();


// hide show password
document.addEventListener("DOMContentLoaded", function() {

    const button = document.getElementById("open_password_cta");
    const form = document.querySelector(".open_password_field");
    const error = document.querySelector(".banner--error");

    // Only keep form open when password is wrong
    if(error){
        button.style.display = "none";
        form.style.display = "block";
    }

    button.addEventListener("click", function(e){
        e.preventDefault();

        button.style.display = "none";
        form.style.display = "block";
    });

});